import { Flex, Progress, Spin } from 'antd'
import isEmpty from 'lodash-es/isEmpty'
import isUndefined from 'lodash-es/isUndefined'
import { FunctionComponent, ReactNode } from 'react'
import styled, { useTheme } from 'styled-components'
import Blur from '@/components/common/blur'
import { NoData } from '@/components/kol/detail/no-data'

type AudienceRegionCityRatioChartProps = {
  blur: boolean
  series?: {
    title: string
    percent: number
  }[]
  loading: boolean
}

const AudienceRegionCityRatioChart: FunctionComponent<
  AudienceRegionCityRatioChartProps
> = ({ series, blur, loading }) => {
  const theme = useTheme()
  if (isUndefined(series)) {
    return null
  }

  return (
    <>
      {((): ReactNode => {
        if (loading) {
          return (
            <Flex align='center' justify='center' style={{ minHeight: 140 }}>
              <Spin />
            </Flex>
          )
        }

        if (isEmpty(series)) {
          return <NoData />
        }

        return (
          <Blur activate={blur}>
            {series.map(({ title: seriesTitle, percent }) => (
              <SeriesWrapper key={seriesTitle}>
                <SeriesTitle>{seriesTitle}</SeriesTitle>
                <Progress
                  percent={percent}
                  strokeColor={theme.colors.brand.secondary}
                  trailColor={theme.colors.base.grey.grey6}
                />
              </SeriesWrapper>
            ))}
          </Blur>
        )
      })()}
    </>
  )
}

const SeriesWrapper = styled.div`
  margin: 0 0 15px;

  .ant-progress {
    display: flex;
    align-items: center;
    height: 20px;
  }

  .ant-progress .ant-progress-inner {
    display: block;
  }

  .ant-progress-text {
    color: ${({ theme }): string => theme.colors.gray10};
    font-size: 15px;
    font-weight: 600;
  }
`

const SeriesTitle = styled.div`
  color: ${({ theme }): string => theme.colors.gray10};
  font-size: 14px;
  line-height: 140%;
`

export default AudienceRegionCityRatioChart
